import System from "../../helper/system";
import Key_config from "./key_config";
import _ from "underscore";
import ProductListingAPICall from "../ProductListingAPICall";
import Product from "@system/config/product";
import store from "../../storeWire";
import Helper from "src/support/Helper";

class ResponseMaker {
    data = {};
    keyConfigMain = Key_config();
    keyConfig = {};
    Count = 0;
    facets = {};
    flagFacets = [];
    processed_payload = {
        value: []
    };

    constructor(data = false) {
        if (data !== false) {
            this.data = data;
            if (this.data && this.data.data && this.data.data.Products !== undefined) {
                this.data.data.products = this.data.data.Products;
            }
        }
        Object.entries(this.keyConfigMain).map((v_IN, i_IN) => {
            this.keyConfig[this.getTheKeyForThisAPIMaker(v_IN[0])] = v_IN[1]
        })
    }

    process = () => {
        return this;
    };

    run = (axios_config = false, raw_config = false) => {
        let categoryFilter_detected = false;
        if (raw_config.p_filter !== undefined && raw_config.p_filter.categoryFilter_detected !== undefined) {
            categoryFilter_detected = raw_config.p_filter.categoryFilter_detected;
        }
        let appendFacadeOptions_detected = false;
        if (raw_config.p_filter !== undefined && raw_config.p_filter.appendFacadeOptions_detected !== undefined) {
            appendFacadeOptions_detected = raw_config.p_filter.appendFacadeOptions_detected;
        }
        let value = [];
        if (this.data && this.data.data && this.data.data.products !== undefined &&
            this.data.data.products.length > 0
        ) {
            this.data.data.products.map((v, i) => {
                let here_v = {};
                if (Object.entries(v).length) {
                    Object.entries(v).map((v_IN, i_IN) => {
                        let keyFromAPI = this.keyConfig[this.getTheKeyForThisAPIMaker(v_IN[0])];
                        let here_value = v_IN[1];
                        // if (keyFromAPI === 'Attributes' &&
                        //     typeof here_value === 'object' &&
                        //     here_value.length !== undefined
                        // ) {
                        //     let att_here = [];
                        //     here_value.map((v_att, i_att) => {
                        //         let att_here_inner = [];
                        //         Object.entries(v_att).map((v_IN_att, i_IN_att) => {
                        //             let key_att_m = this.keyConfig[this.getTheKeyForThisAPIMaker(v_IN_att[0])];
                        //             att_here_inner[key_att_m] = v_IN_att[1];
                        //         });
                        //         att_here[i_att] = att_here_inner;
                        //     });
                        //     here_value = att_here;
                        // }
                        here_v[keyFromAPI] = here_value;
                    })
                }
                if (here_v.ROHSCompliantCode !== undefined) {
                    here_v.ROHSCompliantCodeValue = Product.product__ROHSCompliantCode(here_v.ROHSCompliantCode);
                } else {
                    here_v.ROHSCompliantCodeValue = false;
                }
                if (here_v.NCNRFlag === 'No') {
                    here_v.NCNRFlag = false;
                }
                if (here_v.NCNRFlag === 'N') {
                    here_v.NCNRFlag = false;
                }
                if (here_v.NCNRFlag === 'Yes') {
                    here_v.NCNRFlag = true;
                }
                if (here_v.NCNRFlag === 'Y') {
                    here_v.NCNRFlag = true;
                }
                if (here_v.ObsoleteFlag === 'No') {
                    here_v.ObsoleteFlag = false;
                }
                if (here_v.ObsoleteFlag === 'N') {
                    here_v.ObsoleteFlag = false;
                }
                if (here_v.ObsoleteFlag === 'Yes') {
                    here_v.ObsoleteFlag = true;
                }
                if (here_v.ObsoleteFlag === 'Y') {
                    here_v.ObsoleteFlag = true;
                }
                if (here_v.EndofLifeFlag === 'No') {
                    here_v.EndOfLifeOFlag = false;
                    here_v.EndOfLifeFlag = false;
                }
                if (here_v.EndofLifeFlag === 'N') {
                    here_v.EndOfLifeOFlag = false;
                    here_v.EndOfLifeFlag = false;
                }
                if (here_v.EndofLifeFlag === 'Yes') {
                    here_v.EndOfLifeOFlag = true;
                    here_v.EndOfLifeFlag = true;
                }
                if (here_v.EndofLifeFlag === 'Y') {
                    here_v.EndOfLifeOFlag = true;
                    here_v.EndOfLifeFlag = true;
                }

                here_v.categoryListing = [];
                if (here_v.Level_1_Name && here_v.Level_1_URL) {
                    here_v.categoryListing.push({
                        value: here_v.Level_1_Name,
                        level: 2,
                        url: here_v.Level_1_URL
                    })
                }
                if (here_v.Level_2_Name && here_v.Level_2_URL) {
                    here_v.categoryListing.push({
                        value: here_v.Level_2_Name,
                        level: 2,
                        url: here_v.Level_2_URL
                    })
                }
                if (here_v.Level_3_Name && here_v.Level_3_URL) {
                    here_v.categoryListing.push({
                        value: here_v.Level_3_Name,
                        level: 3,
                        url: here_v.Level_3_URL
                    })
                }
                if (here_v.Level_4_Name && here_v.Level_4_URL) {
                    here_v.categoryListing.push({
                        value: here_v.Level_4_Name,
                        level: 4,
                        url: here_v.Level_4_URL
                    })
                }
                // If ERPPartNumber is blank this is backup logic to use
                // ManufacturerPartNumber has ERPPartNumber
                here_v.ERPPartNumberModified = false;
                if (here_v.ERPPartNumber === undefined ||
                    here_v.ERPPartNumber === null ||
                    here_v.ERPPartNumber === '' ||
                    here_v.ERPPartNumber === ' '
                ) {
                    here_v.ERPPartNumber = here_v.ItemNumber;
                    here_v.ERPPartNumberModified = true;
                }

                // Export Parameters
                if (here_v.ERPMFRPartNumber !== undefined &&
                    here_v.ERPMFRPartNumber !== null &&
                    here_v.ERPMFRPartNumber !== '') {
                    here_v.PartNumber = here_v.ERPMFRPartNumber;
                }

                if (here_v.QtyMin !== undefined &&
                    here_v.QtyMin !== null &&
                    here_v.QtyMin > -1) {
                    here_v.Quantity = here_v.QtyMin;
                    here_v.Min = here_v.QtyMin;
                }

                if (here_v.QtyMult !== undefined &&
                    here_v.QtyMult !== null &&
                    here_v.QtyMult > -1) {
                    here_v.Mult = here_v.QtyMult;
                }

                if (here_v.ShortDescription !== undefined) {
                    here_v.ProductDescription = here_v.ShortDescription !== null &&
                        here_v.ShortDescription !== '' ? here_v.ShortDescription : '';
                }
                here_v.DatasheetUrl = ''
                if(Helper.valueIsNotNull(here_v.IHSManufacturerDatasheetURL))
                {
                    // here_v.Datasheet = here_v.IHSManufacturerDatasheetURL;
                    here_v.DatasheetUrl = here_v.IHSManufacturerDatasheetURL;
                }
                else if (Helper.valueIsNotNull(here_v.ManufacturerDatasheetURL)) {
                    here_v.DatasheetUrl = here_v.ManufacturerDatasheetURL;
                }


                if (here_v.ManufacturerName !== undefined) {
                    here_v.Manufacturer = here_v.ManufacturerName !== null && here_v.ManufacturerName !== '' ? here_v.ManufacturerName : '';
                }

                /**
                 * Story #   : 14603
                 * Change #  : AssetURL Override and set thumbnailpath
                 * Change by : Pankaj
                 * Date      : 17 Oct,2023
                 */
                if (here_v.ThumbnailPath !== undefined) {
                    here_v.AssetURL = here_v.ThumbnailPath !== null && here_v.ThumbnailPath !== '' ? here_v.ThumbnailPath : ''
                }

                if (here_v.ImagePath !== undefined) {
                    here_v.ImagePath = here_v.ImagePath !== null && here_v.ImagePath !== '' ? here_v.ImagePath : ''
                }
                if (here_v.VendorCode) {
                    here_v.VendorCode = here_v.VendorCode
                }
                if (here_v.SAPMatgroup) {
                    here_v.SAPMatgroup = here_v.SAPMatgroup
                }

                if (here_v.Stock) {
                    here_v.Stock = here_v.Stock
                }
                else {
                    here_v.Stock = 0;
                }

                if (Helper.valueIsNotNull(here_v.FarnellInventorySharing) && !here_v.ERPPartNumberModified) {
                    here_v.FarnellInventorySharing = here_v.FarnellInventorySharing.toLowerCase() === 'yes' ? true : false;
                }
                else {
                    here_v.FarnellInventorySharing = false;
                }
                
                if (here_v.TopProducts) {
                    here_v.TopProducts = here_v.TopProducts
                }
                value[i] = here_v;
            })
        }
        this.processed_payload.value = value;

        if (this.data && this.data.data) {
            if (this.data.data.Count !== undefined) {
                this.Count = this.data.data.Count;
            }

            if (this.data.data.Categories !== undefined) {
                this.facets['Categories'] = this.processCategories(this.data.data.Categories);
            }
            if (this.data.data.NPI !== undefined) {
                this.facets['NPI'] = this.processNPI(this.data.data.NPI.webContentView);
            }
            if (this.data.data.Documents !== undefined) {
                this.facets['Documents'] = this.processDocuments(this.data.data.Documents.webContentView);
            }
            if (this.data.data.Articles !== undefined) {
                this.facets['Articles'] = this.processArticles(this.data.data.Articles.webContentView);
            }
            if (this.data.data.Videos !== undefined) {
                this.facets['Videos'] = this.processVideos(this.data.data.Videos.webContentView);
            }
            if (this.data.data.Events !== undefined) {
                this.facets['Events'] = this.processEvents(this.data.data.Events.webContentView);
            }
            if (this.data.data.Other !== undefined) {
                this.facets['Other'] = this.processOther(this.data.data.Other.webContentView);
            }
            if (this.data.data.Manufacturer !== undefined) {
                this.facets['ManufacturerName'] = this.processManufacturerName(this.data.data.Manufacturer);
            }
            if (this.data.data.ProductFamily !== undefined) {
                this.facets['FamilyName'] = this.processFamilyName(this.data.data.ProductFamily);
            }
            if (this.data.data.FlagFacets !== undefined) {
                this.flagFacets = this.processFlagFacets(this.data.data.FlagFacets);
            }
            if (categoryFilter_detected !== false && this.data.data.Attributes !== undefined) {
                this.facets['Attributes'] = this.processAttributes(this.data.data.Attributes);
            }
            if (appendFacadeOptions_detected !== false && this.data.data.Attributes !== undefined) {
                this.facets['Attributes'] = this.processAttributesForAppendFacadeOptionFlag(this.data.data.Attributes);
            }
        }

        if (this.facets['Attributes'] !== undefined &&
            Object.entries(this.facets['Attributes']) !== undefined &&
            Object.entries(this.facets['Attributes']['Attributes']) !== undefined &&
            Object.entries(this.facets['Attributes']['Attributes']).length > 0
        ) {
            this.facets['Attributes']['Attributes'].map((v, i) => {
                let v_here = { ...v };
                let slug = System.anythingToCamel(v.value);
                let v_here_Attributes = v.Attributes;
                delete v_here.Attributes;
                this.facets[slug] = {
                    ...v_here,
                    slug: slug,
                    main_label: v_here.name,
                    [slug]: v_here_Attributes
                };
            });
        }
        if (this.processed_payload.value) {
            this.processed_payload.value = this.makeDynamicColumns(this.processed_payload.value);
        }
        return this;
    };

    get = () => {
        return {
            value: this.processed_payload.value,
            '@odata.count': this.Count,
            '@search.facets': this.facets,
            flagFacets: this.flagFacets
        };
    };

    getTheKeyForThisAPIMaker = (key) => {
        return System.getTheKeyForThisAPIMaker(key);
    };

    processAttributesForAppendFacadeOptionFlag = (processAttributes = {}) => {
        let a_main = this.processAttributes(processAttributes);
        let e = store.getState().entities;
        let a = Object.entries(e.ProductListingFilterApplied);
        if (a_main.Attributes !== undefined && a.length) {
            let a_b = {}
            a.map((v) => {
                a_b[v[1].main_label] = v;
            });
            a_main.Attributes.map((v, i) => {
                if (a_b[v.main_label] === undefined) {
                    delete a_main.Attributes[i];
                }
            })
        }
        return a_main;
    };

    processAttributes = (processAttributes = {}) => {
        let f = [];
        let count = 0;
        if (processAttributes && Object.entries(processAttributes).length > 0) {
            Object.entries(processAttributes).map((v, i) => {
                let v_list = this.processFacets(v[1]);
                let v_count = 0;
                v_list.map((v, i) => {
                    v_count = v_count + v.count;
                });
                f.push({
                    value: v[0],
                    main_label: v[0],
                    name: v[0],
                    Attributes: v_list,
                    count: v_count
                });
                count = count + v_count;
            });
        }
        return {
            Attributes: f,
            count,
            slug: 'Attributes',
            main_label: 'Attributes',
            Count: count
        };
    };
    processFamilyName = (processAttributes = {}) => {
        let f = this.processFacets(processAttributes);
        let count = 0;
        if (f.length > 0) {
            f.map((v) => {
                count = count + v.count
            })
        }
        return {
            FamilyName: f,
            count,
            slug: 'FamilyName',
            main_label: 'Product Family',
            Count: count
        };
    };
    processFlagFacets = (processFlagFacets = {}) => {
        let f = [];
        let count = 0;
        if (processFlagFacets && processFlagFacets.length > 0) {
            processFlagFacets.map((v, i) => {
                f[i] = {
                    ...v,
                    value: v.Value,
                    key: v.Key,
                    main_label: v.Description,
                    name: v.Description,
                    Name: v.Description,
                    slug: v.Value,
                    count: v.Count
                };
                count = count + v.Count;
            });
        }
        return {
            slug: 'flagFacets',
            main_label: 'Flag Facets',
            value: 'Flag Facets',
            Count: count,
            count: count,
            flagFacets: f
        };
    };
    makeDynamicColumns = (value) => {
        let v_f = [];
        if (value && value.length > 0) {
            value.map((v) => {
                let v_h = v;
                let dynamic_columns = {};
                if (v_h.Attributes !== undefined && _.isArray(v_h.Attributes) && v_h.Attributes.length > 0) {
                    v_h.Attributes.map((v) => {
                        let field = System.anythingToCamel(v.ATTRNAME);
                        let search_type = new ProductListingAPICall().getFieldType(field);
                        if (search_type === 'attributes') {
                            dynamic_columns[field] = v.ATTRVAL
                        }
                    })
                }
                v_h.dynamic_columns = dynamic_columns;
                v_f.push(v_h)
            })
        }
        return v_f;
    };

    processManufacturerName = (processAttributes = {}) => {
        let f = this.processFacets(processAttributes);
        let count = 0;
        if (f.length > 0) {
            f.map((v) => {
                count = count + v.count
            })
        }
        return {
            ManufacturerName: f,
            count,
            slug: 'ManufacturerName',
            main_label: 'Manufacturer',
            Count: count
        };
    };

    processCategories = (processCategories = {}) => {
        let f = [];
        let count = 0;
        if (processCategories && Object.entries(processCategories).length > 0) {
            processCategories = this.processFacets(processCategories);
            processCategories.map((v, i) => {
                let here = {
                    value: v.value,
                    main_label: v.value,
                    Name: v.value,
                    count: v.count
                };
                if (v.Level !== undefined) {
                    here.Level = v.Level;
                }
                if (v.Url !== undefined) {
                    here.Url = v.Url;
                }
                if (v.Categories !== undefined && v.Categories !== null && v.Categories !== '' && v.Categories.length) {
                    let inner_res = this.processCategories(v.Categories);
                    here.Categories = inner_res.Categories;
                }
                count = here.count;
                f.push(here);
            });
        }
        return {
            Categories: f,
            count,
            slug: 'Categories',
            main_label: 'Category',
            Count: count
        };
    };

    processNPI = (processNPI = {}) => {
        let f = [];
        let count = 0;
        if (processNPI && processNPI.length > 0) {
            processNPI.map((v, i) => {
                let here = {};
                if (v.name) {
                    here.name = v.name;
                }
                if (v.shortDescription) {
                    here.shortDescription = v.shortDescription;
                }
                if (v.url) {
                    here.url = v.url;
                }
                count = processNPI.length;
                f.push(here);
            });
        }
        return {
            NPI: f,
            count,
            slug: 'NPI',
            main_label: 'NPI',
            Count: count
        };
    };

    processDocuments = (processDocuments = {}) => {
        let f = [];
        let count = 0;
        if (processDocuments && processDocuments.length > 0) {
            processDocuments.map((v, i) => {

                if (v.name) {
                    let here = {};
                    here.name = v.name;
                    if (v.Manufacturer) {
                        here.manufacturer = v.Manufacturer;
                    }
                    if (v.url) {
                        here.url = v.url;
                    }
                    if (v.MediaType) {
                        here.mediaType = v.MediaType;
                    }
                    count = processDocuments.length;
                    f.push(here);
                }
            });
        }
        return {
            Documents: f,
            count,
            slug: 'Documents',
            main_label: 'Documents',
            Count: count
        };
    };

    processArticles = (processArticles = {}) => {
        let f = [];
        let count = 0;
        if (processArticles && processArticles.length > 0) {
            processArticles.map((v, i) => {
                let here = {};
                if (v.name) {
                    here.name = v.name;
                }
                if (v.url) {
                    here.url = v.url;
                }
                if (v.shortDescription) {
                    here.shortDescription = v.shortDescription;
                }
                if (v['avn_date'] !== undefined) {
                    here.date = Helper.dateFormatFromString(v['avn_date'], true)
                }
                count = processArticles.length;
                f.push(here);
            });
        }
        return {
            Articles: f,
            count,
            slug: 'Articles',
            main_label: 'Articles',
            Count: count
        };
    };

    processVideos = (processVideos = {}) => {
        let f = [];
        let count = 0;
        if (processVideos && processVideos.length > 0) {
            processVideos.map((v, i) => {
                let here = {};
                if (v['AssetName']) {
                    here.name = v.AssetName;
                }
                if (v['AssetUrl'] !== undefined && v['AssetUrl'].includes('||')) {
                    here.url = '';
                    if (v['AssetUrl'].split('||').length > 1) {
                        here.url = 'https://players.brightcove.net/' + v['AssetUrl'].split('||')[1] + '/BkZJhSKu_default/index.html?videoId=' + v['AssetUrl'].split('||')[2];
                    }
                }
                if (v.Manufacturer) {
                    here.manufacturer = v.Manufacturer;
                }
                if (v['LongDescription']) {
                    here.longDesc = v['LongDescription']
                }
                count = processVideos.length;
                f.push(here);
            });
        }
        return {
            Videos: f,
            count,
            slug: 'Videos',
            main_label: 'Videos',
            Count: count
        };
    };

    processEvents = (processEvents = {}) => {
        let f = [];
        let count = 0;
        if (processEvents && processEvents.length > 0) {
            processEvents.map((v, i) => {
                let here = {};
                if (v.name) {
                    here.name = v.name;
                }
                if (v.url) {
                    here.url = v.url;
                }
                if (v.shortDescription) {
                    here.shortDescription = v.shortDescription;
                }
                if (v.avn_date) {
                    here.date = v['avn_date']
                }
                if (v.avn_startdate) {
                    here.startDate = v['avn_startdate'];
                }
                if (v.avn_enddate) {
                    here.endDate = v['avn_enddate'];
                }
                if (v.avn_location) {
                    here.location = v['avn_location'];
                }
                if (v.avn_enddate && v.avn_startdate) {
                    here.eventDate = Helper.dateFormatFromString(v['avn_startdate'], true) + ' - ' + Helper.dateFormatFromString(v['avn_enddate'], true)
                }
                count = processEvents.length;
                f.push(here);
            });
        }
        return {
            Events: f,
            count,
            slug: 'Events',
            main_label: 'Events',
            Count: count
        };
    };

    processOther = (processOther = {}) => {
        let f = [];
        let count = 0;
        if (processOther && processOther.length > 0) {
            processOther.map((v, i) => {
                let here = {};
                if (v.name) {
                    here.name = v.name;
                }
                if (v.url) {
                    here.url = v.url;
                }
                if (v.shortDescription) {
                    here.shortDescription = v.shortDescription;
                }
                count = processOther.length;
                f.push(here);
            });
        }
        return {
            Other: f,
            count,
            slug: 'Other',
            main_label: 'Other',
            Count: count
        };
    };

    processFacets = (facets = []) => {
        let f = [];
        if (facets && facets.length > 0) {
            facets.map((v, i) => {
                f[i] = {
                    ...v,
                    value: v.Name,
                    main_label: v.Name,
                    count: v.Count
                }
            });
        }
        return f;
    };
}

export default ResponseMaker;